import { render, staticRenderFns } from "./ContentSkusLabel.vue?vue&type=template&id=cf857016&scoped=true"
import script from "./ContentSkusLabel.vue?vue&type=script&lang=js"
export * from "./ContentSkusLabel.vue?vue&type=script&lang=js"
import style0 from "./ContentSkusLabel.vue?vue&type=style&index=0&id=cf857016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf857016",
  null
  
)

export default component.exports